import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select", "name"]

  change() {
    const select = this.selectTarget
    const selectedOption = select.options[select.selectedIndex]
    const title = selectedOption.dataset.title

    if (title) {
      this.nameTarget.value = title
    }
  }
}
